export default function (timestamp) {
    const currentTime = new Date().getTime();

    return timestamp > currentTime;
}
